export default __webpack_public_path__ + "static/media/requirement-image2.b393a556.png";